import { render } from "./PatientComponent.vue?vue&type=template&id=3fcff1be&scoped=true"
import script from "./PatientComponent.vue?vue&type=script&lang=js"
export * from "./PatientComponent.vue?vue&type=script&lang=js"

import "./PatientComponent.vue?vue&type=style&index=0&id=3fcff1be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcff1be"]])

export default __exports__